export default "__VITE_ASSET__DMIjf0ho__"